<template>
    <div class="speak-wrapper">
        <a-modal
            class="edit-speak"
            :visible="visible"
            title=""
            :width="600"
            :maskClosable="false"
            :confirm-loading="confirmLoading"
            @ok="handleOk"
            @cancel="handleCancel"
        >
            <a-form :form="form">
                <a-form-item style="display:none;">
                    <a-input v-decorator="['category_id']"></a-input>
                </a-form-item>
                <a-form-item style="width:100%;" :label="$t('program.show_status'/*显示状态*/)">
                    <a-radio-group v-decorator="['is_show', { rules: [{ required: true, message: $t('program.please_choose_show_status'/*请选择显示状态*/ ) }] }]">
                        <a-radio value="1">{{$t('program.show'/*显示*/ )}}</a-radio>
                        <a-radio value="0">{{$t('program.hide'/*隐藏*/ )}}</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item style="width:100%;" :label="$t('program.chinese_name'/*中文名称*/)">
                    <a-input :placeholder="$t('program.please_enter_chinese_name'/*请输入中文名称*/ )" style="width:100%;" v-decorator="['typename_cn', { rules: [{ required: true, message: $t('program.please_enter_chinese_name'/*请输入中文名称*/ ) }] }]"></a-input>
                </a-form-item>
                <a-form-item style="width:100%;" :label="$t('program.english_name'/*英文名称*/)">
                    <a-input :placeholder="$t('program.please_enter_english_name'/*请输入英文名称*/ )" style="width:100%;" v-decorator="['typename_en', { rules: [{ required: false, message: $t('program.please_enter_english_name'/*请输入英文名称*/ ) }] }]"></a-input>
                </a-form-item>
                <!-- 专题分论坛 -->
                <a-form-item :label="$t('program.role_type'/*角色类型*/)">
                    <a-select :placeholder="$t('program.please_choose_role_type'/*请选择角色类型*/ )" v-decorator="['juese', { rules: [{ required: true, message: $t('program.please_choose_role_type'/*请选择角色类型*/ ) }] }]">
                        <a-select-option value="讲者">{{$t('program.speaker'/*讲者*/ )}}</a-select-option>
                        <a-select-option value="术者">{{$t('program.operator'/*术者*/ )}}</a-select-option>
                    </a-select>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
import pick from 'lodash.pick';
const fileds = ['category_id', 'is_show', 'typename_cn', 'typename_en', 'juese'];
export default {
    name: 'editSpeakModal',
    props: {
    },
    data() {
        return {
            visible: false,
            confirmLoading: false,
            form: this.$form.createForm(this)
        };
    },
    methods: {
        showFun(data) {
            this.visible = true
            if (data) {
                this.form.setFieldsValue(pick(data, fileds))
                this.form.setFieldsValue({
                    category_id: data.id
                })
            }
        },
        handleOk() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    values.type = '2'
                    this.confirmLoading = true;
                    this.$request.post({ url: 'editCategory', data: values }).then(res => {
                        this.$message.success(res.message);
                        this.confirmLoading = false;
                        this.$emit('reset')
                        this.handleCancel();
                    }).finally(() => {
                        this.confirmLoading = false;
                    });
                }
            });
        },
        handleCancel() {
            this.form.resetFields();
            this.visible = false;
        }
    },
    created () {
        fileds.forEach(v => this.form.getFieldDecorator(v))
    }
};
</script>
<style lang="less" scoped>
::v-deep .ant-form-item {
    margin-bottom: 5px;
}
::v-deep .ant-modal-body {
    max-height: 72vh;
    overflow-y: auto;
}
</style>